export const SET_USER_DETAILS = 'SET_USER_DETAILS';

const initialState = {
  name: '',
  role: '',
  phone: '',
  phoneAH: '',
  email: '',
  fax: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      const newState = state;
      newState[action.category] = action.data;
      return {
        ...newState,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userDetails.js